import { findLinkEntities } from './findLinkEntities';
import { Link } from './Link';
export var link = {
  strategy: findLinkEntities,
  component: Link
};